import {Component, ConfigOptions} from 'panel';
import {JsxVNode} from 'snabbdom-jsx-lite';

import {getCookie} from 'common/util/cookie';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
import './index.styl';

export interface RecoveryCodeVerificationPageState {
  verificationInProgress: boolean;
  navigationInProgress: boolean;
  formInputEmpty: boolean;
}

export class RecoveryCodeVerificationPage extends Component<RecoveryCodeVerificationPageState> {
  private form: HTMLFormElement;

  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      error: {type: `string`, description: `invalid code error message`},
    };
  }

  get config(): ConfigOptions<RecoveryCodeVerificationPageState> {
    return {
      template,
      defaultState: {verificationInProgress: false, navigationInProgress: false, formInputEmpty: true},
      helpers: {
        onInsert: (node: JsxVNode): void => {
          this.form = node.elm as HTMLFormElement;
        },
        submitForm: (): void => {
          this.update({verificationInProgress: true});
          this.form.submit();
        },
        getCsrfToken: (): string => {
          return getCookie(`csrftoken`);
        },
        handleClickBackButton: (): void => {
          this.update({navigationInProgress: true});
        },
        setIsFormValueEmpty: (ev) => {
          if (ev.target.value.length > 0) {
            this.update({formInputEmpty: false});
          }
        },
      },
    };
  }
}

export const RecoveryCodeVerificationPageEl = defineAndMakeJsxFactory(
  `mp-recovery-code-verification-page`,
  RecoveryCodeVerificationPage,
);
